import { Box } from '@palmetto/palmetto-components';

import { DocumentDocument, Flag, FlagActionHistory } from 'types';

import { FlagHistoryItem } from '../FlagHistoryItem';

interface FlagActionTimelineProps {
  sortedActionHistory: FlagActionHistory[];
  flag: Flag | undefined;
  documents: DocumentDocument[];
  flaggedDocumentWithSingleFile: (DocumentDocument & { files: DocumentDocument['files'] }) | null;
  queueStatusIsApprovedOrConditionallyApproved: boolean;
  isSpecialFlagSection: boolean;
}

export const FlagActionTimeline = ({
  sortedActionHistory,
  flag,
  documents,
  flaggedDocumentWithSingleFile,
  queueStatusIsApprovedOrConditionallyApproved,
  isSpecialFlagSection,
}: FlagActionTimelineProps) => {
  return (
    <Box>
      {sortedActionHistory?.map((action: FlagActionHistory, i: number) => (
        <FlagHistoryItem
          flagSubject={action?.flagSubject}
          note={action?.note}
          date={action?.date as unknown as string}
          changedFromReviewPackageValue={action?.changedFromReviewPackageValue}
          flagDocumentId={action?.fileUpload}
          replacementDocument={documents.find(
            (document: DocumentDocument) => document && document?.id?.toString() === action?.replacementDocumentId,
          )}
          key={`${i}-action-history-item`}
          allowArchive={!queueStatusIsApprovedOrConditionallyApproved}
        />
      ))}

      <FlagHistoryItem
        isOriginal
        flag={flag}
        note={flag?.note}
        date={flag?.date as unknown as string}
        flagDocumentId={flag?.fileUpload}
        flaggedDocument={flaggedDocumentWithSingleFile}
        allowArchive={false}
        isSpecialFlaggedSection={isSpecialFlagSection}
        isLastItem={true}
      />
    </Box>
  );
};
